import { connect } from "react-redux";
import { fetchFormValues,
  fetchAsignments, 
  updateAssignments,
  getPlanNotes,
  createEmailAssignments, 
  assignPartnerWorkouts, 
  createGroup, 
  createClient,
  createAction,
  createScheduleMessage,
  fetchScheduleMessages,
  fetchScheduleMessageDetail,
  deleteScheduleMessage,
  fetchMileStones,
  fetchPARQS,
  createMileStones,
  createPARQ,
  fetchScheduleCall,
  saveBodyMatrix,
  saveWeightMatric,
  fetchBodyMatrixMetas,
  createScheduleCall,
  deleteActionRange,
  deleteBodyMatrixRange,
  deleteWeightMetricRange,
  deleteMileStones,
  deletePARQ,
  updateActionStatus,
  fetchPartners,
  fetchClients,
  fetchActions,
  fetchBodyMatrix,
  fetchWeightMetric,
  fetchGroups, 
  resetClients,
  resetGroups,
  fetchActionRanges,
  fetchBodyMatrixRanges,
  fetchWeightMetricRanges,
  fetchClientNotes
} from "../store/actions/assignments";
import { fetchMoreWorkouts, resetWorkouts } from "../store/actions/workouts";
import { fetchMorePrograms, resetPrograms } from "../store/actions/programs";
import { fetchMoreAutomations, resetAutomations } from "../store/actions/automations";
import { update } from "../store/actions/brand";
import ClientsForm from '../components/assignments/ClientsForm';
import MobileClientsForm from '../components/assignments/MobileClientsForm';
import FeaturedBrandForm from '../components/assignments/FeaturedBrandForm';
import PartnersForm from '../components/assignments/PartnersForm';
import MarketplaceForm from '../components/assignments/MarketplaceForm';
import List from '../components/assignments/List';
import Partners from '../components/assignments/Partners';
import withAuth from '../hocs/withAuth';

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    workoutCats: state.workoutCats,
    workouts: state.workouts.data,
    automations: state.automations.data,
    programCats: state.programCats,
    programs: state.programs.data,
    isLoadMoreWorkouts: state.workouts.isLoadMore,
    isLoadMorePrograms: state.programs.isLoadMore,
    isLoadMoreAutomations: state.automations.isLoadMore,
    groups: state.groups.data,
    isGroupsLoadMore: state.groups.isLoadMore,
    clients: state.clients.data,
    isClientsLoadMore: state.clients.isLoadMore,
    assignments: state.assignments,
    partners: state.partners,
    brandDetails: state.brand.detail,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAsignments: (param) => {
      if (param.params.type === 'automations') {
        return dispatch(fetchScheduleMessages(ownProps.user._id || localStorage.id, {
          ...param.params,
          isAutomation: true
        }));
      } else {
        return dispatch(fetchAsignments(ownProps.user._id || localStorage.id, param));
      }
    },
    fetchActionRanges: (param) => {
      return dispatch(fetchActionRanges(ownProps.user._id || localStorage.id, param));
    },
    fetchScheduleMessages: (param) => {
      return dispatch(fetchScheduleMessages(ownProps.user._id || localStorage.id, param));
    },
    fetchBodyMatrixRanges: (param) => {
      return dispatch(fetchBodyMatrixRanges(ownProps.user._id || localStorage.id, param));
    },
    fetchWeightMetricRanges: (param) => {
      return dispatch(fetchWeightMetricRanges(ownProps.user._id || localStorage.id, param));
    },
    fetchActions: (param) => {
      return dispatch(fetchActions(ownProps.user._id || localStorage.id, param));
    },
    fetchBodyMatrix: (param) => {
      return dispatch(fetchBodyMatrix(ownProps.user._id || localStorage.id, param));
    },
    fetchWeightMetric: (param) => {
      return dispatch(fetchWeightMetric(ownProps.user._id || localStorage.id, param));
    },
    fetchScheduleMessageDetail: (param) => {
      return dispatch(fetchScheduleMessageDetail(ownProps.user._id || localStorage.id, param));
    },
    saveMileStones: (data) => {
      return dispatch(createMileStones(data));
    },
    savePARQ: (data) => {
      return dispatch(createPARQ(data));
    },
    saveBodyMatrix:  (data) => {
      return dispatch(saveBodyMatrix(data));
    },
    saveWeightMatric: (data) => {
      return dispatch(saveWeightMatric(data));
    },
    saveScheduleCall: (data) => {
      return dispatch(createScheduleCall(data));
    },
    fetchMileStones: (param) => {
      return dispatch(fetchMileStones(ownProps.user._id || localStorage.id, param));
    },
    fetchPARQS: (param) => {
      return dispatch(fetchPARQS(ownProps.user._id || localStorage.id, param));
    },
    fetchScheduleCall: (param) => {
      return dispatch(fetchScheduleCall(ownProps.user._id || localStorage.id, param));
    },
    fetchBodyMatrixMetas: () => {
      return dispatch(fetchBodyMatrixMetas());
    },
    saveClientAction: (data) => {
      return dispatch(createAction(data));
    },
    saveScheduleMessage: (data) => {
      return dispatch(createScheduleMessage(data));
    },
    deleteActionRange: (data) => {
      return dispatch(deleteActionRange(data));
    },
    deleteBodyMatrixRange: (data) => {
      return dispatch(deleteBodyMatrixRange(data));
    },
    deleteWeightMetricRange: (data) => {
      return dispatch(deleteWeightMetricRange(data));
    },
    deleteMileStones: (data) => {
      return dispatch(deleteMileStones(data));
    }, 
    deletePARQ: (data) => {
      return dispatch(deletePARQ(data));
    },
    deleteScheduleMessage : (data) => {
      return dispatch(deleteScheduleMessage(data));
    },
    updateActionStatus: (id, type, status) => {
      return dispatch(updateActionStatus(id, type, status));
    }, 
    updateAssignments: (id, status) => {
      return dispatch(updateAssignments(id, status));
    },
    getPlanNotes: (param) => {
      return dispatch(getPlanNotes(param));
    },
    fetch: () => {
      return dispatch(fetchFormValues(ownProps.user._id || localStorage.id));
    },
    fetchClients: (query) => {
      if (query.skip === 0) {
        dispatch(resetClients());
      }
      return dispatch(fetchClients(query));
    },
    fetchGroups: (query) => {
      if (query.skip === 0) {
        dispatch(resetGroups());
      }
      return dispatch(fetchGroups(query));
    },
    resetClients: () => {
      return dispatch(resetClients());
    },
    resetGroups: () => {
      return dispatch(resetGroups());
    },
    fetchMore: (query) => {
      const itemType = query.itemType;
      delete query.itemType;
      if (itemType === 'program') {
        return dispatch(fetchMorePrograms(query));
      } else {
        if (itemType === 'workout') {
          return dispatch(fetchMoreWorkouts(query));
        } else {
          return dispatch(fetchMoreAutomations(query));
        }
      }
    },
    resetWorkouts: () => {
      return dispatch(resetWorkouts());
    },
    resetPrograms: () => {
      return dispatch(resetPrograms());
    },
    resetAutomations: ()  => {
      return dispatch(resetAutomations());
    },
    fetchPartners : () => {
      return dispatch(fetchPartners(ownProps.user._id));
    },
    fetchClientNotes: (query) => {
   
      return dispatch(fetchClientNotes(query));
    },
    assignEmails: (assigns) => {
      return dispatch(createEmailAssignments(assigns));
    },
    createGroup: (groupData) => {
      return dispatch(createGroup(groupData));
    },
    createClient: (clientData) => {
      return dispatch(createClient(clientData));
    },
    assignToPartners: (workoutIds) => {
      return dispatch(assignPartnerWorkouts(workoutIds));
    },
    updateBrand: (brandData) => {
      return dispatch(update(brandData));
    }
  }
}

export const AssignFeaturedBrand = withAuth(connect(mapStateToProps, mapDispatchToProps)(FeaturedBrandForm));
export const AssignClients = withAuth(connect(mapStateToProps, mapDispatchToProps)(ClientsForm));
export const AssignMobileClients = withAuth(connect(mapStateToProps, mapDispatchToProps)(MobileClientsForm));
export const AssignPartners = withAuth(connect(mapStateToProps, mapDispatchToProps)(PartnersForm));
export const AssignMarketplace = withAuth(connect(mapStateToProps, mapDispatchToProps)(MarketplaceForm));
export const MyAssignments = withAuth(connect(mapStateToProps, mapDispatchToProps)(List));
export const MyPartners = withAuth(connect(mapStateToProps, mapDispatchToProps)(Partners));



// WEBPACK FOOTER //
// ./src/containers/Assignments.js